import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Detail from './Detail';

const propTypes = {
  details: PropTypes.arrayOf({}).isRequired,
};

const Wrapper = styled.div``;

function ServiceDetails({ details }) {
  return (
    <Wrapper>
      {!!details &&
        details.map((d, i) => <Detail rightImage={i % 2 === 0} detail={d} />)}
    </Wrapper>
  );
}

ServiceDetails.propTypes = propTypes;

export default ServiceDetails;



// WEBPACK FOOTER //
// ./src/components/HomePage/components/ServiceDetails/ServiceDetails.jsx